import Swal from "sweetalert2";

// @ts-ignore
const { __, _x, _n, _nx } = wp.i18n;

export default function() {
    // @ts-ignore
    if(window.nftMarketplaceCore.isLoggedInWithMetamask) {
        return true;
    }

    Swal.fire(
        _x( 'You are not logged in!', 'nft-marketplace-core' ),
        _x( 'Please log in with metamask to continue.', 'nft-marketplace-core' ),
        'error',
    )

    return false;
}